export const UPDATE_FETCHED_COLLECTIONS = 'UPDATE_FETCHED_COLLECTIONS';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';
